import { api } from 'api/api';
import {
    RetryInvoicePaymentRequestDto,
    RetryInvoicePaymentResultDto,
    SubscriptionInvoiceDto,
} from 'api/dtos/billingDtos';

type ApiResponse<T> = {
    success: boolean;
    data: T;
};

export const billingApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getMyInvoices: builder.query<SubscriptionInvoiceDto[], void>({
            query: () => 'billing/invoices',
            providesTags: ['Subscription'],
            transformResponse: (response: ApiResponse<SubscriptionInvoiceDto[]>) => response.data,
        }),
        downloadMyInvoicePdf: builder.mutation<Blob, string>({
            query: (invoiceId) => ({
                url: `billing/invoices/${invoiceId}/pdf`,
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
        }),
        retryInvoicePayment: builder.mutation<
            ApiResponse<RetryInvoicePaymentResultDto>,
            { invoiceId: string; body?: RetryInvoicePaymentRequestDto }
        >({
            query: ({ invoiceId, body }) => ({
                url: `billing/invoices/${invoiceId}/retry-payment`,
                method: 'POST',
                body: body ?? {},
            }),
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetMyInvoicesQuery,
    useDownloadMyInvoicePdfMutation,
    useRetryInvoicePaymentMutation,
} = billingApi;
